export enum PresenceActionType {
  PRESENCE_ENTER = 'PRESENCE_ENTER',
  PRESENCE_LEAVE = 'PRESENCE_LEAVE',
  PRESENCE_CLEANUP = 'PRESENCE_CLEANUP',
  PRESENCE_MULTI_ENTER = 'PRESENCE_MULTI_ENTER',
}

interface BasePresenceAction {
  type: PresenceActionType;
  resourceId: string;
}

interface PresenceConnection {
  userId: string;
  ablyConnectionId: string;
}

interface PresenceEnterAction extends BasePresenceAction, PresenceConnection {
  type: PresenceActionType.PRESENCE_ENTER;
}

interface PresenceLeaveAction extends BasePresenceAction, PresenceConnection {
  type: PresenceActionType.PRESENCE_LEAVE;
}

interface PresenceCleanupAction extends BasePresenceAction {
  type: PresenceActionType.PRESENCE_CLEANUP;
}

interface PresenceMultiEnterAction extends BasePresenceAction {
  type: PresenceActionType.PRESENCE_MULTI_ENTER;
  members: Array<PresenceConnection>;
}

export function presenceEnter(
  resourceId: string,
  userId: string,
  ablyConnectionId: string
): PresenceEnterAction {
  return {
    type: PresenceActionType.PRESENCE_ENTER,
    resourceId,
    userId,
    ablyConnectionId,
  };
}

export function presenceLeave(
  resourceId: string,
  userId: string,
  ablyConnectionId: string
): PresenceLeaveAction {
  return {
    type: PresenceActionType.PRESENCE_LEAVE,
    resourceId,
    userId,
    ablyConnectionId,
  };
}

export function presenceCleanup(resourceId: string): PresenceCleanupAction {
  return {
    type: PresenceActionType.PRESENCE_CLEANUP,
    resourceId,
  };
}

export function presenceMultiEnter(
  resourceId: string,
  members: Array<PresenceConnection>
): PresenceMultiEnterAction {
  return {
    type: PresenceActionType.PRESENCE_MULTI_ENTER,
    resourceId,
    members,
  };
}

export type PresenceAction =
  | PresenceEnterAction
  | PresenceLeaveAction
  | PresenceCleanupAction
  | PresenceMultiEnterAction;
